import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

export const userSettingsTranslations: any = TranslationBlueprint.make({
  name: 'user-settings-pt-BR',

  params: {
    resource: createTranslationResource({
      ref: userSettingsTranslationRef,
      translations: {
    'pt-BR': () => import('./user-settings-ptbr'),
      },
    }),
  },
});